import { render, staticRenderFns } from "./UserRdvsList.vue?vue&type=template&id=aa6e66b8&"
import script from "./UserRdvsList.vue?vue&type=script&lang=js&"
export * from "./UserRdvsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports